import React from 'react'
import axios from 'axios'
import api from '../../../utils/API';
import ModalPasswordInput from '../../../components/Modals/ModalInputs/ModalPasswordInput';
import { FormattedMessage, injectIntl } from 'react-intl';
import SSOConnecting from './SSO-Connecting'

class SSOSignIn extends React.Component {
  state = {
    email: '',
    password: '',
    rememberMe: false,
    error: '',
    name: '',
    isLogin: false,
    displayConnecting: false,
  }
  delayTimer = 2000;

  handleChange = (event) => {
    const value = event.target.type === 'checkbox' ? event.target.checked : event.target.value
    this.setState({ [event.target.name]: value })
  }

  handleKeyDown = (event) => {
    if (event.key === 'Enter') {   
      //this.handleLogIn(event)
      this.delayHandleLogIn(event)
    }
  }

  errorMessage = (err) => {
    switch(err.response.status) {
      case 400:
        this.setState({ error: <FormattedMessage id="INVALID_PARAMETERS" /> })
        break;
      case 401:
      case 500:
        this.setState({ error: <FormattedMessage id={err.response.data.toUpperCase()} /> })
        break;
      default:
        this.setState({ error: err.message })
    }
    this.setConnectingStaus(false);
  }

  setConnectingStaus = (status) => {
    this.setState({displayConnecting: status})
    this.props.setConnetingStatus(status);
  }

  delayHandleLogIn = (event) => {
    this.setConnectingStaus(true);
    setTimeout(() => {
      this.handleLogIn(event)
    }, this.delayTimer);
  }

  handleLogIn = (event) => {
    event.preventDefault()
    const search = new URLSearchParams(window.location.search)

    if(this.state.isLogin) {
      if(this.props.product === 'CMS') {
        api.loginCms(this.state.email, this.state.password, 
          search.get('cms-id'), search.get('socket-id'))
        .then(res => {
          const { data } = res
          if (data.error) return this.setState({ error: data.error })
          this.props.onSuccess();
        }).catch(err => {
          console.error(err)
          this.errorMessage(err);
        })
      }
      else if (this.props.product === 'CC-Server') {
        api.loginCCServer(this.state.email, this.state.password, 
          search.get('cc-server-id'), search.get('socket-id'))
        .then(res => {
          const { data } = res
          if (data.error) return this.setState({ error: data.error })
          this.props.onSuccess();
        }).catch(err => {
          console.error(err)
          this.errorMessage(err)
        }) 
      }
    } else {
      if(this.props.product === 'CMS') {
        api.registerCms(this.state.email, this.state.password, 
          this.state.name, search.get('socket-id'))
        .then(res => {
          const { data } = res
          if (data.error) return this.setState({ error: data.error })
          this.props.onSuccess();
        }).catch(err => {
          console.error(err)
          this.errorMessage(err)
        })
      }
      else if (this.props.product === 'CC-Server') {
        api.registerCCServer(this.state.email, this.state.password, 
          this.state.name, search.get('socket-id'))
        .then(res => {
          const { data } = res
          if (data.error) return this.setState({ error: data.error })
          this.props.onSuccess();
        }).catch(err => {
          console.error(err)
          this.errorMessage(err)
        })
      }
    }
  }

  componentDidMount = () => {
    const search = new URLSearchParams(window.location.search);
    const cmsId = search.get('cms-id');
    const ccId = search.get('cc-server-id');
    if(cmsId){
      api.getCms(cmsId)
      .then((res) => {
        const { data } = res;
        if (data.error) return this.setState({ error: data.error })
        this.setState({
          isLogin: true,
          name: data.name,
        })
      }).catch(err => {
        console.error(err)
        this.setState({ error: `${err.response.data}. Re-registering instead.` })
      })
    }
    if(ccId){
      api.getCCServer(ccId)
      .then((res) => {
        const { data } = res;
        if (data.error) return this.setState({ error: data.error })
        this.setState({
          isLogin: true,
          name: data.name,
        })
      }).catch(err => {
        console.error(err)
        this.setState({ error: `${err.response.data}. Re-registering instead.` })
      })
    }
  };

    render() {
      if(this.state.displayConnecting) {
        return(
          <SSOConnecting progressValue='100'/>
        )
      }else{
        return(
            <div className='card'>
                <div className='header text-center'>
                  <h2><FormattedMessage id="CMSE_LOGIN_TITLE" /></h2>
                  <h3><FormattedMessage id="CMSE_LOGIN_SUB_TITLE" /></h3>
                </div>
                <div className='form-outline mt-2 mb-2'>
                    <label className='form-label' htmlFor='form2Example1'><FormattedMessage id="EMAIL" /></label>
                    <input onChange={this.handleChange} value={this.state.email} name='email' type='email' className='form-control rounded-1' />
                </div>
                <div className='form-outline mb-2'>
                  <label className='form-label' htmlFor='form2Example2'><FormattedMessage id="PASSWORD" /></label>
                  <ModalPasswordInput 
                    onChange={this.handleChange} 
                    value={this.state.password} 
                    name="password" 
                    className="form-control"
                  />
                </div>
                <div className='form-outline row'>
                <label className='col-6 form-label label_hover blue'  htmlFor='form2Example2'onClick={this.props.onResendVerificationEmail}><FormattedMessage id="RESEND_VERIFICATION_EMAIL" /></label>
                <label className='col-6 form-label label_hover text-align-right blue'  htmlFor='form2Example2'onClick={this.props.onForgotPassword}><FormattedMessage id="FORGOT_LOGIN_PASSWORD" /></label>
                </div>
                <div className='form-outline mb-4'>
                    <label className='form-label' htmlFor='form2Example3'>{this.props.product}</label>
                    <input 
                      disabled={this.state.isLogin} 
                      onChange={this.handleChange} 
                      value={this.state.name} 
                      onKeyDown={(e) => { this.handleKeyDown(e) }} 
                      name='name' 
                      className='form-control rounded-1' 
                      placeholder={this.props.intl.formatMessage({id: "ASSIGN_NAME_FOR_CMSE"})}
                    />
                </div>

                {this.state.error ? <p className='error'>ERROR: {this.state.error}</p> : null}
                <button type='button' className='btn btn-primary btn-block' onClick={this.delayHandleLogIn/*this.handleLogIn*/}><FormattedMessage id="CONNECT_BTN" /></button>
                <div className='mt-2 text-center'>
                    <label className='form-label'><FormattedMessage id="DONT_ACCOUNT" /></label>
                    <label className='form-label label_hover red ms-2' onClick={this.props.onAgreeTerms}><FormattedMessage id="SIGN_UP" /></label>
                </div>
            </div>
        )
      }
    }
}

export default injectIntl(SSOSignIn);